// extracted by mini-css-extract-plugin
export var quillEditor = "_j7-1";
export var variable = "_j7-0";